import { useState } from "react";
import { Fuel, Route } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";

export default function PolicySettings({ tenant, reload }) {
  const s = tenant.settings || {};
  const [form, setForm] = useState({
    monthly_fuel_budget_rm: s.monthly_fuel_budget_rm ?? "",
    max_trip_distance_km: s.max_trip_distance_km ?? "",
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings", {
        monthly_fuel_budget_rm: form.monthly_fuel_budget_rm === "" ? 0 : Number(form.monthly_fuel_budget_rm),
        max_trip_distance_km: form.max_trip_distance_km === "" ? 0 : Number(form.max_trip_distance_km),
      });
      toast.success("Polisi disimpan");
      reload();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-5">
      <Card className="border-slate-200 shadow-sm">
        <CardHeader>
          <CardTitle className="font-heading text-base flex items-center gap-2"><Route className="h-4 w-4" /> Bajet & Kawalan Perjalanan</CardTitle>
          <CardDescription>Had bajet bahan api fleet dan kawalan permohonan tempahan.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="space-y-1.5">
              <Label>Bajet Bahan Api Bulanan (RM, pilihan)</Label>
              <Input data-testid="settings-fuel-budget-input" type="number" min="0" step="100" value={form.monthly_fuel_budget_rm}
                onChange={(e) => setForm({ ...form, monthly_fuel_budget_rm: e.target.value })} placeholder="Cth: 25000" />
              <p className="text-xs text-muted-foreground">Biarkan kosong jika tiada had bajet.</p>
            </div>
            <div className="space-y-1.5">
              <Label>Had Anggaran Jarak Setempahan (KM, pilihan)</Label>
              <Input data-testid="settings-max-distance-input" type="number" min="0" step="10" value={form.max_trip_distance_km}
                onChange={(e) => setForm({ ...form, max_trip_distance_km: e.target.value })} placeholder="Cth: 500" />
              <p className="text-xs text-muted-foreground">Tempahan melebihi had dipaparkan dengan amaran semasa kelulusan.</p>
            </div>
          </div>
          <p className="text-xs bg-indigo-50 border border-indigo-200 text-[#10056E] rounded-lg p-3 flex items-center gap-2" data-testid="policy-fuel-price-note">
            <Fuel className="h-3.5 w-3.5 shrink-0" /> Harga minyak seliter (termasuk Harga BUDI) kini diurus di <b>Tetapan → Harga Minyak</b>.
          </p>
        </CardContent>
      </Card>

      <Button onClick={save} disabled={saving} className="bg-[#10056E] hover:bg-[#2a17a8]" data-testid="settings-save-btn">
        {saving ? "Menyimpan..." : "Simpan Tetapan"}
      </Button>
    </div>
  );
}
